// src/components/AdminPostMapPicker.tsx
import React from 'react';
import { useJsApiLoader, GoogleMap, Marker } from '@react-google-maps/api';

type LatLng = {
  latitude: number;
  longitude: number;
};

type Props = {
  value: LatLng | null;
  onChange: (value: LatLng) => void;
};

const containerStyle: React.CSSProperties = {
  width: '100%',
  height: '300px',
};

const defaultCenter = { lat: 35.681236, lng: 139.767125 }; // 東京駅あたり

const AdminPostMapPicker: React.FC<Props> = ({ value, onChange }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'xross-admin-post-map',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  });

  const handleClick = (e: google.maps.MapMouseEvent) => {
    if (!e.latLng) return;
    onChange({
      latitude: e.latLng.lat(),
      longitude: e.latLng.lng(),
    });
  };

  if (!isLoaded) {
    return <div>マップを読み込み中です…</div>;
  }

  const center = value
    ? { lat: value.latitude, lng: value.longitude }
    : defaultCenter;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14}
      onClick={handleClick}
    >
      {value && (
        <Marker position={{ lat: value.latitude, lng: value.longitude }} />
      )}
    </GoogleMap>
  );
};

export default AdminPostMapPicker;
